module.exports = __webpack_public_path__ + "static/media/down-arrow.b61bc36d.svg";